import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import {authUserSet} from 'containers/App/actions'
import { getAuth, onAuthStateChanged } from "firebase/auth";

import * as routes from '../../constants/routes';

const withAuthentication = (Component) => {
  class WithAuthentication extends React.PureComponent {
    componentDidMount() {
      const { onSetAuthUser } = this.props;

      let publicPages= []
      publicPages.push(routes.SIGN_UP)
      publicPages.push(routes.SIGN_IN)
      publicPages.push(routes.PASSWORD_FORGET)
      publicPages.push(routes.HOME)
      publicPages.push(routes.PRIVACY_POLICY)
      publicPages.push(routes.TERMS_OF_SERVICE)
      publicPages.push(routes.LOGIN)
      publicPages.push(routes.JOIN)
      publicPages.push(routes.ACCOUNT_FORGET)
      publicPages.push(routes.INVITE)
      
      const auth = getAuth();
      this.unregisterAuthObserver = onAuthStateChanged(auth , (authUser) => {
        authUser ? onSetAuthUser(authUser) : onSetAuthUser(null);
          if (!authUser) {
            let cleanPath = this.props.history.location.pathname.split('/')
            if(!publicPages.includes("/"+cleanPath[1])){
              if(!this.props.history.location.pathname.includes(routes.INVITE)){
                this.props.history.push(routes.SIGN_IN);
              }
            }
          }
      });
    }

    componentWillUnmount() {
      this.unregisterAuthObserver();
    }

    render() {
      return (
        <Component />
      );
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    onSetAuthUser: (authUser) => dispatch(authUserSet(authUser)),
  });

  return  compose(
    withRouter,
    connect(null, mapDispatchToProps)
  )(WithAuthentication);
}

export default withAuthentication;